import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'password-meter',
  templateUrl: './password-meter.component.html',
  styleUrls: ['./password-meter.component.scss']
})
export class PasswordMeterComponent implements OnInit, OnChanges {

  @Input() password: string;
  score: number = 0;
  segmentNumber: number = 5
  segment: string[] = []

  ngOnInit(): void {
    this.segment = Array(this.segmentNumber).fill(null);
  }

  ngOnChanges() {
    this.score = meterStrong(this.password);
    if (this.score === 0) this.segment = Array(this.segmentNumber).fill(null);
    if (this.score === 1) {
      this.segment = Array(this.segmentNumber).fill(null);
      this.segment[0] = 'red'
    }
    if (this.score === 2) {
      this.segment = Array(this.segmentNumber).fill(null);
      this.segment = Array(this.segmentNumber,).fill('yellow', 0, 2);
    }
    if (this.score === 3) {
      this.segment = Array(this.segmentNumber).fill(null);
      this.segment = Array(this.segmentNumber,).fill('yellow', 0, 3);
    }
    if (this.score === 4) {
      this.segment = Array(this.segmentNumber).fill(null);
      this.segment = Array(this.segmentNumber,).fill('green', 0, 4);
    }
    if (this.score === 5) this.segment = Array(this.segmentNumber).fill('green');
  }
}


export const meterStrong = (password: string): number => {
  let weakRegex: RegExp = /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/;
  let mediumRegex: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
  let strongRegex: RegExp = /^(?!.*(.)\1\1)(?!.*(123|234|345|456|567|678|789|890))(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/;
  // let strongRegex: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})(?!.*(\w)\1{3,}).+$/;
  let veryStrongRegex: RegExp = /^(?!.*(.)\1\1)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{10,}$/;
  let score = 0;

  if (password?.length > 0) score += 1;
  if (weakRegex.test(password)) score += 1;
  if (mediumRegex.test(password)) score += 1;
  if (strongRegex.test(password)) score += 1;
  if (veryStrongRegex.test(password)) score = 5;
  return score;
}